import axios from 'axios';

import router from '../router'

import moment from 'moment'

//import { faAcquisitionsIncorporated } from '@fortawesome/free-brands-svg-icons';

// DEBUGGER
//var baseUrl = "http://localhost:5001";

// DEV WEB SERVER
//var baseUrl = "http://10.0.0.46" ; //EngageAPI";

// TEST WEB SERVER
//var baseUrl = "http://34.196.154.96:82" ; //EngageAPI";

// LIVE WEB SERVER 
//var baseUrl = "https://www.ehealthengagement.com" ; //EngageAPI";

function send(path, message)
{
  return new Promise((resolve, reject) =>
  { 
    axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate, max-age=0',
        'Pragma': 'no-cache' 
      },
      dataType: "json",
      //url: baseUrl + "/EngageAPI" + path, 
      url: window.Vue.prototype.$config.api_url + "/EngageAPI" + path,
      responseType: 'json',
      data: message
    }) 
    .then( response =>
    {
      resolve( response );
    })
    .catch( error =>
    {
      /* alert("error=" + error.isAxiosError);
      for(var propertyName in error) {
        alert("error=" + propertyName);
     } */
      reject( error );
    });
  });
}
export const DATE_SUPPORT =
{
  formatDate : function(d)
  {
    return moment(d).format('YYYY-MM-DD') 
  }, 
}
export const SUPPORT =
{
  isSupported : function() 
  {
    
    var platform = ["Win32", "Win16", "Win16", "iPad", "iPhone"];
    
    for (var i = 0; i < platform.length; i++) {

        if (navigator.platform.indexOf(platform[i]) >- 1) {

            //return platform[i];
            return true;
        }
    }
    return false;
  },
 
  clearSession : function()
  {
    window.sessionKey = '';

   /*  let menuLogoff = document.getElementById('menuLogoff');
    //let menuSignon = document.getElementById('menuSignon');
    menuLogoff.classList.add('is-hidden');
    //menuSignon.classList.remove('is-hidden'); */

    document.getElementById('menuLogoff').classList.add('is-hidden');
  },
  securityCheck: function(errorId)
  {
    if(errorId == "4000")
    {
      SUPPORT.clearSession();
      router.push( { path: "/"} );
    }
  },
  showServiceMenus: function()
  {
    // SHOW ALL
    document.getElementById('menuMedicalHistory').classList.remove('is-hidden');
    document.getElementById('menuCOVID19Questionnaire').classList.remove('is-hidden');
    document.getElementById('menuQuestionnaire').classList.remove('is-hidden');
    document.getElementById('menuMedicalTests').classList.remove('is-hidden');
    document.getElementById('menuAppointments').classList.remove('is-hidden');
    document.getElementById('menuOptionalConsents').classList.remove('is-hidden');
    // THIS IS CORRECT document.getElementById('menuPhysicianNetwork').classList.remove('is-hidden');
    document.getElementById('menuDashboard').classList.remove('is-hidden');
    document.getElementById('menuInvite').classList.remove('is-hidden');

    // REMOVE SPECIFICS
    if(window.defaultDailyQuestionnaireTypeId == 1) // COVID
    {
      document.getElementById('menuQuestionnaire').classList.add('is-hidden');
      document.getElementById('menuDashboard').classList.add('is-hidden');
    }
    else if(window.defaultDailyQuestionnaireTypeId == 2)  // FIT FOR DUTY
    {
      document.getElementById('menuCOVID19Questionnaire').classList.add('is-hidden');
      document.getElementById('menuDashboard').classList.add('is-hidden');
    }
    else if(window.defaultDailyQuestionnaireTypeId == 3)  // DASHBOARD
    {
      document.getElementById('menuCOVID19Questionnaire').classList.add('is-hidden');
      document.getElementById('menuQuestionnaire').classList.add('is-hidden');
    }
  },
  hideServiceMenus: function()
  {
    document.getElementById('menuMedicalHistory').classList.add('is-hidden');
    document.getElementById('menuCOVID19Questionnaire').classList.add('is-hidden');
    document.getElementById('menuQuestionnaire').classList.add('is-hidden');
    document.getElementById('menuDashboard').classList.add('is-hidden');
    document.getElementById('menuMedicalTests').classList.add('is-hidden');
    document.getElementById('menuAppointments').classList.add('is-hidden');
    document.getElementById('menuOptionalConsents').classList.add('is-hidden');
    document.getElementById('menuInvite').classList.add('is-hidden');
  }
}

export const API =
{
  getPlatform :function()
  {
    return window.Vue.prototype.$config.environment;
  },
  signon : function(username,
                  password,
                  locale)
  { 
    return new Promise((resolve, reject) =>
    {
      
      send(
        "/authentication/signon",
        { "userName": username,
        "password": password,
        "applicationTypeId": 4,
        "version": process.env.VUE_APP_VERSION, //"1.1.0.1",
        "language": locale, //"en-us",
        "operatingSystem": window.navigator.platform,
        "ipAddress": "1.1.1.1"}) // FIX THIS!!!!!!!!!!!!!
        .then( response => {
          resolve( response )
        })
      .catch( error =>
      {
        reject( error );
      });
    });
  },
  changePassword : function(sessionKey,
    originalPassword,
    password)
  {
    return new Promise((resolve, reject) =>
    {
      send(
        "/authentication/changePassword",
        { 
        "sessionKey": sessionKey,
        "language": process.env.VUE_APP_I18N_LOCALE, 
        "originalPassword": originalPassword,
        "password":password
        }).then( response => {
          resolve( response );
        })
      .catch( error => {
        reject( error );
      });
    });
  },
  recoverPassword : function(emailAddress,
                            username)
  {
    return new Promise((resolve, reject) =>
    {
      send(
        "/authentication/recoverPassword",
        { 
        "language": process.env.VUE_APP_I18N_LOCALE, 
        "emailAddress": emailAddress,
        "userName": username
        }).then( response => {
          resolve( response );
        })
      .catch( error => {
        reject( error );
      });
    });
  },
  logoff : function(sessionKey)
  {
    
    return new Promise((resolve, reject) =>
    {
      send(
        "/authentication/logoff",
        { 
          "sessionKey": sessionKey
        }).then( response => {
          
          //window.sessionKey = ''; THIS DOES NOT HAVE ACCESS TO WINDOW OBJECT
          
          let menuLogoff = document.getElementById('menuLogoff');
          let menuSignon = document.getElementById('menuSignon');
          menuLogoff.classList.add('is-hidden');
          menuSignon.classList.remove('is-hidden');
          resolve( response );
        })
      .catch( error => {
        reject( error );
      });
    });
  },
  readConsent: function(sessionKey, locale, consentTemplateItemUsageId)
  {
    return new Promise((resolve, reject) =>
    {
      
      send(
      "/authentication/readConsent",
      { 
        "sessionKey": sessionKey,
        "language": locale,
        "consentTemplateItemUsageId": consentTemplateItemUsageId
      })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  createConsent: function(sessionKey, consents, locale)
  {
    return new Promise((resolve, reject) =>
    { 
      send(
      "/authentication/createConsent",
      { 
        "sessionKey": sessionKey,
        "consents" : consents,
        "language": locale,
      })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  createC19RiskAssessment : function(sessionKey,
    c19RiskAssessmentProfileId,
    currentlyHaveC19,
    previousTestedPositiveC19,
    previousTestedPositiveC19A,
    previousTestedPositiveC19B,
    previousTestedPositiveC19C,
    contactWithC19DiagnosedPerson,
    contactWithC19DiagnosedPersonExplain,
    contactWithC19Traveler,
    contactWithC19TravelerCountryId,
    contactWithC19TravelerExplain,
    chronicConditions,
    chronicConditionsExplain,
    compromisedImmunity,
    compromisedImmunityExplain,
    vaccination,
    vaccineId,
    vaccineDose1,
    vaccineDose2,
    vaccineDose3,
    temperature,
    temperaturePastNDays,
    usedDigitalThermometer,
    wetCoughProductive,
    wetCoughNonProductive,
    dryCough,
    soreThroat,
    congestionRunningNose,
    shortnessOfBreath,
    chills,
    headache,
    lossOfSmell,
    lossOfTaste,
    lossOfAppetite,
    pinkEye,
    bodyAchesMuscleJointPain,
    suddenConfusion,
    digestiveSystem,
    fatigue,
    chestpain,
    symptomStartDate,
    MH1FeelingToday,
    MH1FeelingTodayWeeks,
    MH1FeelingTodayWeeksNervousAnxious,
    MH1FeelingTodayWeeksWorrying,
    MH1FeelingTodayWeeksDepression,
    MH1FeelingTodaySuicidalHomicidal,
    MH2WakeRestful,
    MH2WakeRestfulHoursOfSleep,
    MH2WakeRestfulSleepTimeliness,
    MH3FollowingDoctorOrders,
    MH4TakingPrescribedMeds,
    MH5Accommodations,
    MH5AccommodationsJobApplicationAdjustment,
    MH5AccommodationsWorkScheduleModification,
    MH5AccommodationsEqualBenefitsChange,
    MH5AccommodationsDoctorsAppointment,
    MH6Other,
    MH6OtherExplain
    )
  {
    return new Promise((resolve, reject) =>
    {
      send(
      "/c19/RiskAssessment/createRiskAssessment",
      { 
        "sessionKey": sessionKey,
        "language": process.env.VUE_APP_I18N_LOCALE,
        "c19RiskAssessmentProfileId": c19RiskAssessmentProfileId,
        "currentlyHaveC19": currentlyHaveC19,
        "previousTestedPositiveC19": previousTestedPositiveC19,
        "previousTestedPositiveC19A": previousTestedPositiveC19A,
        "previousTestedPositiveC19B": previousTestedPositiveC19B,
        "previousTestedPositiveC19C": previousTestedPositiveC19C,
        "contactWithC19DiagnosedPerson": contactWithC19DiagnosedPerson,
        "contactWithC19DiagnosedPersonExplain": contactWithC19DiagnosedPersonExplain,
        "contactWithC19Traveler": contactWithC19Traveler,
        "contactWithC19TravelerCountryId": contactWithC19TravelerCountryId,
        "contactWithC19TravelerExplain": contactWithC19TravelerExplain,
        "chronicConditions": chronicConditions,
        "chronicConditionsExplain": chronicConditionsExplain,
        "compromisedImmunity": compromisedImmunity,
        "compromisedImmunityExplain": compromisedImmunityExplain,
        // SECTION 4
        "vaccination": vaccination,
        "vaccineId": vaccineId,
        "vaccineDose1":vaccineDose1,
        "vaccineDose2":vaccineDose2,
        "vaccineDose3":vaccineDose3,

        // SECTION 2
        "temperature": temperature,
        "temperaturePastNDays":temperaturePastNDays,
        "usedDigitalThermometer":usedDigitalThermometer,
        // SECTION 3
        "wetCoughProductive": wetCoughProductive,
        "wetCoughNonProductive": wetCoughNonProductive,
        "dryCough": dryCough,
        "soreThroat": soreThroat,
        "congestionRunningNose": congestionRunningNose,
        "shortnessOfBreath": shortnessOfBreath,
        "chills": chills,
        "headache": headache,
        "lossOfSmell": lossOfSmell,
        "lossOfTaste": lossOfTaste,
        "lossOfAppetite": lossOfAppetite,
        "pinkEye": pinkEye,
        "bodyAchesMuscleJointPain": bodyAchesMuscleJointPain,
        "suddenConfusion": suddenConfusion,
        "digestiveSystem": digestiveSystem,
        "fatigue": fatigue,
        "chestpain": chestpain,
        "symptomStartDate": symptomStartDate,
        // SECTION 5
        "MH1FeelingToday": MH1FeelingToday,
        "MH1FeelingTodayWeeks": MH1FeelingTodayWeeks,
        "MH1FeelingTodayWeeksNervousAnxious": parseInt(MH1FeelingTodayWeeksNervousAnxious),
        "MH1FeelingTodayWeeksWorrying": parseInt(MH1FeelingTodayWeeksWorrying),
        "MH1FeelingTodayWeeksDepression": parseInt(MH1FeelingTodayWeeksDepression),
        "MH1FeelingTodaySuicidalHomicidal": parseInt(MH1FeelingTodaySuicidalHomicidal),
        "MH2WakeRestful": MH2WakeRestful,
        "MH2WakeRestfulHoursOfSleep": parseInt(MH2WakeRestfulHoursOfSleep),
        "MH2WakeRestfulSleepTimeliness": MH2WakeRestfulSleepTimeliness,
        "MH3FollowingDoctorOrders": MH3FollowingDoctorOrders,
        "MH4TakingPrescribedMeds": MH4TakingPrescribedMeds,
        "MH5Accommodations": MH5Accommodations,
        "MH5AccommodationsJobApplicationAdjustment": MH5AccommodationsJobApplicationAdjustment,
        "MH5AccommodationsWorkScheduleModification": MH5AccommodationsWorkScheduleModification,
        "MH5AccommodationsEqualBenefitsChange": MH5AccommodationsEqualBenefitsChange,
        "MH5AccommodationsDoctorsAppointment": MH5AccommodationsDoctorsAppointment,
        "MH6Other": MH6Other,
        "MH6OtherExplain": MH6OtherExplain
      })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  readRiskAssessmentQuestionnaire : function(sessionKey, locale)
  {
    return new Promise((resolve, reject) =>
    {
      
      send(
      "/c19/RiskAssessment/readRiskAssessmentQuestionnaire",
      { 
        "sessionKey": sessionKey,
        "language": locale,
      })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  readStateList: function()
  {
    return [
      { id: "0", text:"Select-one" }, 
      { id: "1", text:"Alabama" }, 
      { id: "2", text:"Alaska" }, 
      { id: "3", text:"Arizona" }, 
      { id: "4", text:"Arkansas" }, 
      { id: "5", text:"California" }, 
      { id: "6", text:"Colorado" }, 
      { id: "7", text:"Connecticut" }, 
      { id: "8", text:"Delaware" }, 
      { id: "9", text:"Florida" }, 
      { id: "10", text:"Georgia" }, 
      { id: "11", text:"Hawaii" }, 
      { id: "12", text:"Idaho" }, 
      { id: "13", text:"Illinois" }, 
      { id: "14", text:"Indiana" }, 
      { id: "15", text:"Iowa" }, 
      { id: "16", text:"Kansas" }, 
      { id: "17", text:"Kentucky" }, 
      { id: "18", text:"Louisiana" }, 
      { id: "19", text:"Maine" }, 
      { id: "20", text:"Maryland" }, 
      { id: "21", text:"Massachusetts" }, 
      { id: "22", text:"Michigan" }, 
      { id: "23", text:"Minnesota" }, 
      { id: "24", text:"Mississippi" }, 
      { id: "25", text:"Missouri" }, 
      { id: "26", text:"Montana" }, 
      { id: "27", text:"Nebraska" }, 
      { id: "28", text:"Nevada" }, 
      { id: "29", text:"New Hampshire" }, 
      { id: "30", text:"New Jersey" }, 
      { id: "31", text:"New Mexico" }, 
      { id: "32", text:"New York" }, 
      { id: "33", text:"North Carolina" }, 
      { id: "34", text:"North Dakota" }, 
      { id: "35", text:"Ohio" }, 
      { id: "36", text:"Oklahoma" }, 
      { id: "37", text:"Oregon" }, 
      { id: "38", text:"Pennsylvania" }, 
      { id: "39", text:"Rhode Island" }, 
      { id: "40", text:"South Carolina" }, 
      { id: "41", text:"South Dakota" }, 
      { id: "42", text:"Tennessee" }, 
      { id: "43", text:"Texas" }, 
      { id: "44", text:"Utah" }, 
      { id: "45", text:"Vermont" }, 
      { id: "46", text:"Virginia" }, 
      { id: "47", text:"Washington" }, 
      { id: "48", text:"Washington, DC" }, 
      { id: "49", text:"West Virginia" }, 
      { id: "50", text:"Wisconsin" }, 
      { id: "51", text:"Wyoming" }];
    
  },
  readHistorySource: function(locale)
  {
    if(locale == "es")
    {
      return [ 
        { id: "0", text:"Seleccione-uno" },
        { id: "1", text:"Yo" },
        { id: "2", text:"Esposa" },
        { id: "3", text:"Compañera" },
        { id: "4", text:"Familia" },
        { id: "5", text:"Amigo" },
        { id: "6", text:"Registros médicos" },
        { id: "7", text:"Guardián legal" } 
      ]
    }
    else
    {
      return [ 
        { id: "0", text:"Select-one" },
        { id: "1", text:"Self" },
        { id: "2", text:"Spouse" },
        { id: "3", text:"Partner" },
        { id: "4", text:"Family" },
        { id: "5", text:"Friend" },
        { id: "6", text:"Medical Records" },
        { id: "7", text:"Legal Guardian" } 
      ]
    }
  },
  readIntake: function(sessionKey, locale)
  {
    return new Promise((resolve, reject) =>
    {
      send(
        "/member/Intake/readIntake",
        { 
          "sessionKey": sessionKey,
          "language": locale,
        }).then( response => {
          
          resolve( response );
        })
      .catch( error => {
        reject( error );
      });
    });
  },
  updateIntake: function(sessionKey,
    locale,
    stage,
    first,
    middle,
    last,
    street,
    suite,
    city,
    stateId,
    zipcode,
    email,
    phone,
    phoneExt,
    cell,
    fax,
    dateOfBirth,
    gender,
    languageId,
    handednessId,
    insurancePayer,
    planName,
    planType,
    coverageEffectiveDate,
    planGroupNumber,
    insuranceIdentifier,
    driversLicense,
    driversLicenseStateId,
    driversLicenseClassId,
    cplCdlApplicationHolder,
    usdotFmcsaCertDenied,
    sourceOfHistoryId,
    hadSurgery,
    hadSurgeryExplanation,
    takingMedications,
    takingMedicationsExplanation,
    headBrain,
    headBrainNote,
    seizuresEpilepsy,
    seizuresEpilepsyNote,
    eyeProblems,
    eyeProblemsNote,
    earHearingProblems,
    earHearingProblemsNote,
    heartDisease,
    heartDiseaseNote,
    paceMakerStents,
    paceMakerStentsNote,
    highBloodPressure,
    highBloodPressureNote,
    highCholesterol,
    highCholesterolNote,
    chronicCough,
    chronicCoughNote,
    lungDisease,
    lungDiseaseNote,
    kidneyProblems,
    kidneyProblemsNote,
    stomachLiver,
    stomachLiverNote,
    diabetes,
    diabetesNote,
    insulinUsed,
    insulinUsedNote,
    anxietyDepression,
    anxietyDepressionNote,
    fainting,
    faintingNote,
    dizzinessHeadaches,
    dizzinessHeadachesNote,
    unexplainedWeightLoss,
    unexplainedWeightLossNote,
    stroke,
    strokeNote,
    missingLimitedUserOfArms,
    missingLimitedUserOfArmsNote,
    neckBack,
    neckBackNote,
    boneMuscle,
    boneMuscleNote,
    cancer,
    cancerNote,
    chronicInfection,
    chronicInfectionNote,
    sleepingDisorders,
    sleepingDisordersNote,
    sleepTest,
    sleepTestNote,
    nightInHospital,
    nightInHostpitalNote,
    brokenBone,
    brokenBoneNote,
    useTobacco,
    useTobaccoNote,
    drinkAlcohol,
    drinkAlcoholNote,
    illegalSubstance,
    illegalSubstanceNote,
    everFailedDrugTest,
    everFailedDrugTestNote,
    otherHealthCondition,
    otherHealthConditionNote,
    bloodClotsBleeding,
    bloodClotsBleedingNote,
    anyPrecludingCondition,
    anyPrecludingConditionNote,
    treatedForSubstance,
    treatedForSubstanceNote,
    wereYouHospitalized,
    wereYouHospitalizedNote,
    hipaaAcknowledgement,
    hipaaAcknowledgementDigitalSignature,
    hipaaAcknowledgementTimeStamp,
    medicalRecordsReleaseAcknowledgement,
    medicalRecordsReleaseAcknowledgementDigitalSignature,
    medicalRecordsReleaseAcknowledgementTimeStamp,
    teleHealthInformedConsent,
    teleHealthInformedConsentDigitalSignature,
    teleHealthInformedConsentTimeStamp)
  {
    
    return new Promise((resolve, reject) =>
    {
      send(
      "/member/Intake/updateIntake",
      { 
        "sessionKey": sessionKey, 
        "language": locale,
        "stage": stage,
        "first": first,
        "middle": middle,
        "last": last,
        "street": street,
        "suite": suite,
        "city": city,
        "stateId": stateId,
        "zipcode": zipcode,
        "email": email,
        "phone": phone,
        "phoneExt": phoneExt,
        "cell": cell,
        "fax": fax,
        "dateOfBirth": dateOfBirth,
        "gender": gender,
        "languageId": parseInt(languageId),
        "handednessId": parseInt(handednessId),
        "insurancePayer": insurancePayer,
        "planName": planName,
        "planType": planType,
        "coverageEffectiveDate": coverageEffectiveDate,
        "planGroupNumber": planGroupNumber,
        "insuranceIdentifier": insuranceIdentifier,
        "driversLicense": driversLicense,
        "driversLicenseStateId": parseInt(driversLicenseStateId),
        "driversLicenseClassId": parseInt(driversLicenseClassId),
        "cplCdlApplicationHolder": cplCdlApplicationHolder,
        "usdotFmcsaCertDenied": usdotFmcsaCertDenied,
        "sourceOfHistoryId": parseInt(sourceOfHistoryId),
        "hadSurgery": hadSurgery,
        "hadSurgeryExplanation": hadSurgeryExplanation,
        "takingMedications": takingMedications,
        "takingMedicationsExplanation": takingMedicationsExplanation,
        "headBrain": headBrain,
        "headBrainNote": headBrainNote,
        "seizuresEpilepsy": seizuresEpilepsy,
        "seizuresEpilepsyNote": seizuresEpilepsyNote,
        "eyeProblems": eyeProblems,
        "eyeProblemsNote": eyeProblemsNote,
        "earHearingProblems": earHearingProblems,
        "earHearingProblemsNote": earHearingProblemsNote,
        "heartDisease": heartDisease,
        "heartDiseaseNote": heartDiseaseNote,
        "paceMakerStents": paceMakerStents,
        "paceMakerStentsNote": paceMakerStentsNote,
        "highBloodPressure": highBloodPressure,
        "highBloodPressureNote": highBloodPressureNote,
        "highCholesterol": highCholesterol,
        "highCholesterolNote": highCholesterolNote,
        "chronicCough": chronicCough,
        "chronicCoughNote": chronicCoughNote,
        "lungDisease": lungDisease,
        "lungDiseaseNote": lungDiseaseNote,
        "kidneyProblems": kidneyProblems,
        "kidneyProblemsNote": kidneyProblemsNote,
        "stomachLiver": stomachLiver,
        "stomachLiverNote": stomachLiverNote,
        "diabetes": diabetes,
        "diabetesNote": diabetesNote,
        "insulinUsed": insulinUsed,
        "insulinUsedNote": insulinUsedNote,
        "anxietyDepression": anxietyDepression,
        "anxietyDepressionNote": anxietyDepressionNote,
        "fainting": fainting,
        "faintingNote": faintingNote,
        "dizzinessHeadaches": dizzinessHeadaches,
        "dizzinessHeadachesNote": dizzinessHeadachesNote,
        "unexplainedWeightLoss": unexplainedWeightLoss,
        "unexplainedWeightLossNote": unexplainedWeightLossNote,
        "stroke": stroke,
        "strokeNote": strokeNote,
        "missingLimitedUserOfArms": missingLimitedUserOfArms,
        "missingLimitedUserOfArmsNote": missingLimitedUserOfArmsNote,
        "neckBack": neckBack,
        "neckBackNote": neckBackNote,
        "boneMuscle": boneMuscle,
        "boneMuscleNote": boneMuscleNote,
        "cancer": cancer,
        "cancerNote": cancerNote,
        "chronicInfection": chronicInfection,
        "chronicInfectionNote": chronicInfectionNote,
        "sleepingDisorders": sleepingDisorders,
        "sleepingDisordersNote": sleepingDisordersNote,
        "sleepTest": sleepTest,
        "sleepTestNote": sleepTestNote,
        "nightInHospital": nightInHospital,
        "nightInHostpitalNote": nightInHostpitalNote,
        "brokenBone": brokenBone,
        "brokenBoneNote": brokenBoneNote,
        "useTobacco": useTobacco,
        "useTobaccoNote": useTobaccoNote,
        "drinkAlcohol": drinkAlcohol,
        "drinkAlcoholNote": drinkAlcoholNote,
        "illegalSubstance": illegalSubstance,
        "illegalSubstanceNote": illegalSubstanceNote,
        "everFailedDrugTest": everFailedDrugTest,
        "everFailedDrugTestNote": everFailedDrugTestNote,
        "otherHealthCondition": otherHealthCondition,
        "otherHealthConditionNote": otherHealthConditionNote,
        "bloodClotsBleeding": bloodClotsBleeding,
        "bloodClotsBleedingNote": bloodClotsBleedingNote,
        "anyPrecludingCondition": anyPrecludingCondition,
        "anyPrecludingConditionNote": anyPrecludingConditionNote,
        "treatedForSubstance": treatedForSubstance,
        "treatedForSubstanceNote": treatedForSubstanceNote,
        "wereYouHospitalized": wereYouHospitalized,
        "wereYouHospitalizedNote": wereYouHospitalizedNote,
        "hipaaAcknowledgement": hipaaAcknowledgement,
        "hipaaAcknowledgementDigitalSignature": hipaaAcknowledgementDigitalSignature,
        "hipaaAcknowledgementTimeStamp": hipaaAcknowledgementTimeStamp,
        "medicalRecordsReleaseAcknowledgement": medicalRecordsReleaseAcknowledgement,
        "medicalRecordsReleaseAcknowledgementDigitalSignature": medicalRecordsReleaseAcknowledgementDigitalSignature,
        "medicalRecordsReleaseAcknowledgementTimeStamp": medicalRecordsReleaseAcknowledgementTimeStamp,
        "teleHealthInformedConsent": teleHealthInformedConsent,
        "teleHealthInformedConsentDigitalSignature": teleHealthInformedConsentDigitalSignature,
        "teleHealthInformedConsentTimeStamp": teleHealthInformedConsentTimeStamp   
      })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  readMedicalTest: function(sessionKey, locale)
  {
    return new Promise((resolve, reject) =>
    { 
      send(
        "/member/MedicalTest/readMedicalTest",
        { 
          "sessionKey": sessionKey, 
          "language": locale
        })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  readInvite: function(sessionKey, locale)
  {
    return new Promise((resolve, reject) =>
    { 
      send(
        "/member/Invite/readInvite",
        { 
          "sessionKey": sessionKey, 
          "language": locale
        })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  updateInvite: function(sessionKey, inviteId, action, locale)
  {
    return new Promise((resolve, reject) =>
    { 
      send(
        "/member/Invite/updateInvite",
        { 
          "sessionKey": sessionKey, 
          "inviteId": inviteId,
          "action": action,
          "language": locale
        })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  readPhysicians: function(sessionKey, 
                          oppCode, 
                          first,
                          last,
                          zipcode,
                          phone,
                          licenseNumber,
                          nationalProviderId,
                          drugEnforcementAgencyId, 
                          locale)
  {
    return new Promise((resolve, reject) =>
    { 
      send(
        "/physician/Physician/readPhysicians",
        { 
          "sessionKey": sessionKey, 
          "oppCode": oppCode, 
          "first": first,
          "last": last,
          "zipcode": zipcode,
          "phone": phone,
          "licenseNumber": licenseNumber,
          "nationalProviderId": nationalProviderId,
          "drugEnforcementAgencyId": drugEnforcementAgencyId, 
          "language": locale
        })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  createPhysician: function(sessionKey, physicianId,locale)
  {
    return new Promise((resolve, reject) =>
    { 
      send(
        "/physician/Physician/createPhysician",
        { 
          "sessionKey": sessionKey, 
          "physicianId": physicianId,
          "language": locale
        })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  deletePhysician: function(sessionKey, physicianId,locale)
  {
    return new Promise((resolve, reject) =>
    { 
      send(
        "/physician/Physician/deletePhysician",
        { 
          "sessionKey": sessionKey, 
          "physicianId": physicianId,
          "language": locale
        })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  createDailyQuestionnaire : function(sessionKey,
      dailyQuestionnaireTypeId,
      sec1MoodRating,
      sec2IllnessFeelingSick,
      sec2IllnessInterfereWithDuties,
      sec2IllnessExplanation,
      sec2StressFeelingStress ,
      sec2StressLongWorkloadHours,
      sec2StressWorkplaceChallenges,
      sec2StressPersonalCauses,
      sec2StressExplanation,
      sec2AlcoholWithinPast24Hours,
      sec2AlcoholHoursSinceLastDrink,
      sec2FatigueExperiencing,
      sec2FatigueMuscular,
      sec2FatigueMental,
      sec2FatigueEmotional,
      sec2FatigueLackOfSleep,
      sec2FatigueChronicLackOfSleep,
      sec2FatigueExplanation,
      sec2EmotionRecentTrauma,
      sec2EmotionExplanation,
      sec3MentalHealthFeelingToday,
      sec3MentalHealthPast2Weeks,
      sec3MentalHealthNervouseAnxious,
      sec3MentalHealthWorrying,
      sec3MentalHealthNoInterest,
      sec3MentalHealthDepressed,
      sec3MentalHealthSuicidalHomicidal,
      sec3FatigueWakeRestful,
      sec3FatigueHoursOfSleep,
      sec3FatigueSleepSameTime,
      sec3FatigueUseCPAP,
      sec3FatigueUseCPAPDuringLastSleep,
      sec3FatigueCPAPRequired,
      sec3InstructionsFollowingDoctorOrders,
      sec3MedsTakingAny,
      sec3MedsTakingAsPrescribed,
      sec3MedsStateOfMind,
      sec3MedsInterfereWithJob,
      sec3MedsTakingSupplements,
      sec3MedsExplanation,
      sec3AccommodationNeeded,
      sec3AccomodationJobAppAdjustment,
      sec3AccommodationScheduleModification,
      sec3AccommodationEqualBenefitsChange,
      sec3AccommodationDoctorsAppointment,
      sec3OtherBotheringYou,
      sec3OtherExplanation,
      sec3TempValue,
      sec3TempPastNDays,
      sec3TempUsedDigitalThermometer,
      sec3SymptomWetCoughProductive,
      sec3SymptomWetCoughNonProductive,
      sec3SymptomDryCough,
      sec3SymptomSoreThroat,
      sec3SymptomCongestionRunningNose,
      sec3SymptomShortnessOfBreath,
      sec3SymptomChills,
      sec3SymptomHeadache,
      sec3SymptomLossOfSmell,
      sec3SymptomLossOfTaste,
      sec3SymptomLossOfAppetite,
      sec3SymptomPinkEye,
      sec3SymptomBodyAchesPain,
      sec3SymptomSuddenConfusion,
      sec3SymptomDigestiveSystem,
      sec3SymptomFatigue,
      sec3SymptomChestPain,
      sec3SymptomStartDate,
      sec4PanProfileUpToDate,
      sec4PanCurrentlyHaveC19,
      sec4PanPrevTestedPositiveForC19,
      sec4PanPrevTestedPositiveForC19A,
      sec4PanPrevTestedPositiveForC19B,
      sec4PanPrevTestedPositiveForC19C,
      sec4PanContactWithC19DiagnosedPerson,
      sec4PanContactWithC19DiagnosedPersonExplain,
      sec4PanContactWithC19Traveler,
      sec4PanContactWithC19TravelerCountryId,
      sec4PanContactWithC19TravelerExplain,
      sec4PanChronicConditions,
      sec4PanChronicConditionsExplain,
      sec4PanCompromisedImmunity,
      sec4PanCompromisedImmunityExplain,
      vaccination,
      vaccineId,
      vaccineDose1,
      vaccineDose2,
      vaccineDose3
    )
  {
    return new Promise((resolve, reject) =>
    {
      
      send(
      "/member/DailyQuestionnaire/createDailyQuestionnaire",
      { 
        "sessionKey": sessionKey,
        "language": process.env.VUE_APP_I18N_LOCALE,
        "dailyQuestionnaireTypeId": dailyQuestionnaireTypeId,
        //"dailyQuestionnaireStatusId": dailyQuestionnaireStatusId,
        "sec1MoodRating": sec1MoodRating,
        "sec2IllnessFeelingSick": sec2IllnessFeelingSick,
        "sec2IllnessInterfereWithDuties": sec2IllnessInterfereWithDuties,
        "sec2IllnessExplanation": sec2IllnessExplanation,
        "sec2StressFeelingStress":  sec2StressFeelingStress,
        "sec2StressLongWorkloadHours": sec2StressLongWorkloadHours,
        "sec2StressWorkplaceChallenges": sec2StressWorkplaceChallenges,
        "sec2StressPersonalCauses": sec2StressPersonalCauses,
        "sec2StressExplanation": sec2StressExplanation,
        "sec2AlcoholWithinPast24Hours": sec2AlcoholWithinPast24Hours,
        "sec2AlcoholHoursSinceLastDrink": sec2AlcoholHoursSinceLastDrink,
        "sec2FatigueExperiencing": sec2FatigueExperiencing,
        "sec2FatigueMuscular": sec2FatigueMuscular,
        "sec2FatigueMental": sec2FatigueMental,
        "sec2FatigueEmotional": sec2FatigueEmotional,
        "sec2FatigueLackOfSleep": sec2FatigueLackOfSleep,
        "sec2FatigueChronicLackOfSleep": sec2FatigueChronicLackOfSleep,
        "sec2FatigueExplanation": sec2FatigueExplanation,
        "sec2EmotionRecentTrauma": sec2EmotionRecentTrauma,
        "sec2EmotionExplanation": sec2EmotionExplanation,
        "sec3MentalHealthFeelingToday": sec3MentalHealthFeelingToday,
        "sec3MentalHealthPast2Weeks": sec3MentalHealthPast2Weeks,
        "sec3MentalHealthNervouseAnxious": sec3MentalHealthNervouseAnxious,
        "sec3MentalHealthWorrying": sec3MentalHealthWorrying,
        "sec3MentalHealthNoInterest": sec3MentalHealthNoInterest,
        "sec3MentalHealthDepressed": sec3MentalHealthDepressed,
        "sec3MentalHealthSuicidalHomicidal": sec3MentalHealthSuicidalHomicidal,
        "sec3FatigueWakeRestful": sec3FatigueWakeRestful,
        "sec3FatigueHoursOfSleep": sec3FatigueHoursOfSleep,
        "sec3FatigueSleepSameTime": sec3FatigueSleepSameTime,
        "sec3FatigueUseCPAP": sec3FatigueUseCPAP,
        "sec3FatigueUseCPAPDuringLastSleep": sec3FatigueUseCPAPDuringLastSleep,
        "sec3FatigueCPAPRequired": sec3FatigueCPAPRequired,
        "sec3InstructionsFollowingDoctorOrders": sec3InstructionsFollowingDoctorOrders,
        "sec3MedsTakingAny": sec3MedsTakingAny,
        "sec3MedsTakingAsPrescribed" : sec3MedsTakingAsPrescribed,
        "sec3MedsStateOfMind": sec3MedsStateOfMind,
        "sec3MedsInterfereWithJob": sec3MedsInterfereWithJob,
        "sec3MedsTakingSupplements": sec3MedsTakingSupplements,
        "sec3MedsExplanation": sec3MedsExplanation,
        "sec3AccommodationNeeded": sec3AccommodationNeeded,
        "sec3AccomodationJobAppAdjustment": sec3AccomodationJobAppAdjustment,
        "sec3AccommodationScheduleModification": sec3AccommodationScheduleModification,
        "sec3AccommodationEqualBenefitsChange": sec3AccommodationEqualBenefitsChange,
        "sec3AccommodationDoctorsAppointment": sec3AccommodationDoctorsAppointment,
        "sec3OtherBotheringYou": sec3OtherBotheringYou,
        "sec3OtherExplanation": sec3OtherExplanation,
        "sec3TempValue": sec3TempValue,
        "sec3TempPastNDays": sec3TempPastNDays,
        "sec3TempUsedDigitalThermometer": sec3TempUsedDigitalThermometer,
        "sec3SymptomWetCoughProductive": sec3SymptomWetCoughProductive,
        "sec3SymptomWetCoughNonProductive": sec3SymptomWetCoughNonProductive,
        "sec3SymptomDryCough": sec3SymptomDryCough,
        "sec3SymptomSoreThroat": sec3SymptomSoreThroat,
        "sec3SymptomCongestionRunningNose": sec3SymptomCongestionRunningNose,
        "sec3SymptomShortnessOfBreath": sec3SymptomShortnessOfBreath,
        "sec3SymptomChills": sec3SymptomChills,
        "sec3SymptomHeadache": sec3SymptomHeadache,
        "sec3SymptomLossOfSmell": sec3SymptomLossOfSmell,
        "sec3SymptomLossOfTaste": sec3SymptomLossOfTaste,
        "sec3SymptomLossOfAppetite": sec3SymptomLossOfAppetite,
        "sec3SymptomPinkEye": sec3SymptomPinkEye,
        "sec3SymptomBodyAchesPain": sec3SymptomBodyAchesPain,
        "sec3SymptomSuddenConfusion": sec3SymptomSuddenConfusion,
        "sec3SymptomDigestiveSystem": sec3SymptomDigestiveSystem,
        "sec3SymptomFatigue": sec3SymptomFatigue,
        "sec3SymptomChestPain": sec3SymptomChestPain,
        "sec3SymptomStartDate": sec3SymptomStartDate,
        "sec4PanProfileUpToDate": sec4PanProfileUpToDate,
        "sec4PanCurrentlyHaveC19": sec4PanCurrentlyHaveC19,
        "sec4PanPrevTestedPositiveForC19": sec4PanPrevTestedPositiveForC19,
        "sec4PanPrevTestedPositiveForC19A": sec4PanPrevTestedPositiveForC19A,
        "sec4PanPrevTestedPositiveForC19B": sec4PanPrevTestedPositiveForC19B,
        "sec4PanPrevTestedPositiveForC19C": sec4PanPrevTestedPositiveForC19C,
        "sec4PanContactWithC19DiagnosedPerson": sec4PanContactWithC19DiagnosedPerson,
        "sec4PanContactWithC19DiagnosedPersonExplain": sec4PanContactWithC19DiagnosedPersonExplain,
        "sec4PanContactWithC19Traveler": sec4PanContactWithC19Traveler,
        "sec4PanContactWithC19TravelerCountryId": sec4PanContactWithC19TravelerCountryId,
        "sec4PanContactWithC19TravelerExplain": sec4PanContactWithC19TravelerExplain,
        "sec4PanChronicConditions": sec4PanChronicConditions,
        "sec4PanChronicConditionsExplain": sec4PanChronicConditionsExplain,
        "sec4PanCompromisedImmunity": sec4PanCompromisedImmunity,
        "sec4PanCompromisedImmunityExplain": sec4PanCompromisedImmunityExplain,
        "vaccination": vaccination,
        "vaccineId": vaccineId,
        "vaccineDose1":vaccineDose1,
        "vaccineDose2":vaccineDose2,
        "vaccineDose3":vaccineDose3
      })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  readDailyQuestionnaire : function(sessionKey)
  {
    return new Promise((resolve, reject) =>
    {
      
      send(
      "/member/DailyQuestionnaire/readDailyQuestionnaire",
      { 
        "sessionKey": sessionKey,
        "language": process.env.VUE_APP_I18N_LOCALE
      })
      .then( response => {
        resolve( response );
      })
      .catch( error => {
        reject( error );
      });
    });
  },
  readAppointments: function(sessionKey, locale)
  {
    return new Promise((resolve, reject) =>
    {
      send(
        "/appointments/Appointments/readAppointments",
        { 
          "sessionKey": sessionKey,
          "language": locale,
        }).then( response => {
          
          resolve( response );
        })
      .catch( error => {
        reject( error );
      });
    });
  },
}

